import React, {Component} from 'react';
import {connect} from 'formik';
import IntervalSliderWidget from '../../widgets/IntervalSliderWidget';
import CustomRadio from './CustomRadio';

class IntervalSliderField extends Component {
    constructor(props) {
        super(props);
        this.validate = this.validate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeExclusive = this.handleChangeExclusive.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id) {
            this.props.formik.unregisterField(prevProps.id);
            this.props.formik.registerField(this.props.id, this);
        }
    }

    validate(value) {
        return this.props.validate(value);
    }

    handleChange(e) {
        const {formik, id} = this.props;
        formik.setFieldValue(id, e);
    }

    handleChangeExclusive(e) {
        const {formik, id, exclusiveChoice} = this.props;
        formik.setFieldValue(id, exclusiveChoice.id);
    }

    render() {
        const {id, min, max, minLabel, maxLabel, step, interval, exclusiveChoice, value} = this.props;
        const params = {
            min,
            max,
            minLabel,
            maxLabel,
            step,
            interval,
            pristine: exclusiveChoice && value === exclusiveChoice.id,
            value,
        };

        return (
            <div className="form-group">
                <IntervalSliderWidget {...params} onChange={this.handleChange} >
                    {exclusiveChoice &&
                        <CustomRadio extraClass={`custom-radio-interval-exclusive ${params.minLabel? 'spacer': ''}`}
                            id={`intervalslider-${id}_${exclusiveChoice.id}`} name={id}
                            value={exclusiveChoice.id}
                            checked={value === exclusiveChoice.id}
                            onChange={this.handleChangeExclusive}>
                            {exclusiveChoice.value}
                        </CustomRadio>
                    }
                </IntervalSliderWidget>
            </div>
        );
    }
}

export default connect(IntervalSliderField);
